import { render, staticRenderFns } from "./Refs.vue?vue&type=template&id=2d037d00&scoped=true&"
import script from "./Refs.vue?vue&type=script&lang=js&"
export * from "./Refs.vue?vue&type=script&lang=js&"
import style0 from "./Refs.vue?vue&type=style&index=0&id=2d037d00&prod&lang=css&"
import style1 from "./Refs.vue?vue&type=style&index=1&id=2d037d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d037d00",
  null
  
)

export default component.exports